import { validateEmail } from '@/lib/validate';
import * as yup from 'yup';

export interface LostPasswordFormValues {
  email: string;
}

/** Yup schema for lost-password: valid email only. */
export function createLostPasswordSchema(t: (key: string) => string) {
  return yup.object({
    email: yup
      .string()
      .required(() => t('signup_required_email'))
      .test('email', function (value) {
        const result = validateEmail(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
  });
}
